export const styles = {
  dialogHeader: {
    padding: '16px 24px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  dialogContentText: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.6)',
    padding: '0px 24px',
    marginTop: 10,
  },
};

export const muiStyles = {
  dialogTitle: {
    padding: 0,
  },
  dialogContent: {
    padding: 0,
  },
};

export const warningButtonStyles = {
  color: 'white',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(237, 108, 2, 0.85)',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  },
  transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
};
